import * as React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";

const Paginations = ({ page, count, paginationData }) => {
  return (
    <Stack width={"345px"} alignItems={"center"} justifyContent={"center"}>
      <Pagination
        count={count}
        defaultPage={page}
        variant="text"
        onChange={(event, value) => paginationData(value)}
        shape="rounded"
        sx={{
          "& .MuiPaginationItem-previousNext": {
            "& .MuiTouchRipple-root": {
              boxShadow: "unset",
            },
          },
          "& .MuiPaginationItem-root": {
            width: "15px",
            height: "30px",
            borderRadius: "8px",
          },
          "& .MuiPaginationItem-root:hover": {
            backgroundColor: "#17dfba",
            width: 32,
            height: 32,
            color: "white",
          },
          "& .Mui-selected": {
            backgroundColor: "#17dfba !important",
            color:"white !important" ,
          },
          "& .MuiTouchRipple-root": {
            boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.11)",
          },
        }}
      />
    </Stack>
  );
};
export default Paginations;
